/**
 * The sheet docked along the bottom of a phone's map, under the card's tab bar: the host page's
 * own (the recording map's Activity sheet), else elevation-panel-v2's when it's switched on.
 * Null when neither is there and the bar opens the card's own Elevation sheet.
 */
export function dockedSheetSnap(hostSnap: string | null | undefined, panelV2Enabled: boolean, panelV2Snap: string): string | null {
  if (hostSnap != null) return hostSnap;
  return panelV2Enabled ? panelV2Snap : null;
}

export interface MobileTabBarState {
  /** The bar's Elevation button, which a docked sheet makes redundant. */
  showElevationTab: boolean;
  /** Lifted to sit on a docked sheet's peek rather than the screen's edge. */
  aboveSheet: boolean;
  hidden: boolean;
}

/** The card's Details | Elevation bar on a phone, given what's open and what's docked under it. */
export function mobileTabBar(detailsOpen: boolean, elevationOpen: boolean, sheetSnap: string | null): MobileTabBarState {
  const docked = sheetSnap !== null;
  return {
    showElevationTab: !docked,
    aboveSheet: docked && sheetSnap === 'peek',
    hidden: detailsOpen || (!docked && elevationOpen) || (docked && sheetSnap !== 'peek'),
  };
}
